
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from '@/contexts/UserContext';
import { useIsNewUser } from '@/hooks/useIsNewUser';
import UnifiedHeader from './UnifiedHeader';
import GuestHeader from './landing/GuestHeader';
import Navigation from './Navigation';

const HeaderManager: React.FC = React.memo(() => {
  const { isAuthenticated } = useUser();
  const { isNewUser, isLoading: newUserLoading } = useIsNewUser();
  const location = useLocation();
  
  // Memoize header visibility logic for better performance
  const headerConfig = useMemo(() => {
    const isLegalPage = location.pathname === '/terms' || location.pathname === '/privacy';
    const isHowItWorksPage = location.pathname === '/how-forkast-meal-planning-works';
    const isFaqPage = location.pathname === '/meal-planning-app-faqs';
    const isInstallPage = location.pathname === '/install';
    const isTipsPage = location.pathname === '/meal-planning-tips';
    const isMealInspirationPage = location.pathname === '/meal-inspiration';
    const isAuthPage = location.pathname.startsWith('/auth/');
    
    return {
      showGuestHeader: !isAuthenticated && (isLegalPage || isHowItWorksPage || isFaqPage || isInstallPage || isTipsPage || isMealInspirationPage) && !isAuthPage,
      showUnifiedHeader: isAuthenticated,
      showDesktopNavigation: isAuthenticated && !newUserLoading
    };
  }, [location.pathname, isAuthenticated, newUserLoading]);

  return (
    <>
      {headerConfig.showGuestHeader && <GuestHeader />}
      {headerConfig.showUnifiedHeader && <UnifiedHeader />}
      {headerConfig.showDesktopNavigation && <Navigation />}
    </>
  );
});

HeaderManager.displayName = 'HeaderManager';

export default HeaderManager;
